import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./aptech.png"
								alt="facebook"
								className="work-image"
							/>
							<div className="work-title">Aptech</div>
							<div className="work-subtitle">
								Software Engineer
							</div>
							<div className="work-duration">2025 - Present</div>
						</div>

						<div className="work">
							<img
								src="./sybrid.png"
								alt="twitter"
								className="work-image"
							/>
							<div className="work-title">Sybrid</div>
							<div className="work-subtitle">
								Software Engineer
							</div>
							<div className="work-duration">2025 - Present</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
